import dayjs from "dayjs";

const config = {
  rowSelection: false,
  fieldControl: false,
  searchMode: "group",
  columns: [
    {
      title: "渠道ID",
      dataIndex: "channelId",
      width: 200
    },
    {
      title: "渠道名称",
      dataIndex: "channelName",
      width: 150,
      ellipsis: true,
    },
    {
      title: "合作门店",
      dataIndex: "orgList",
      render: 'orgListRender',
      ellipsis: true,
      width: 280
    },
    {
      title: "合作方式",
      dataIndex: "cooperateModeName",
      width: 130
    },
    {
      title: "合作范围",
      dataIndex: "cooperateRangeName",
      width: 120
    },
    {
      title: "渠道分类",
      dataIndex: "channelCategoryName",
      ellipsis: true,
      width: 200
    },
    {
      title: "军种",
      dataIndex: "typeName",
      width: 150
    },
    {
      title: "主被动属性",
      dataIndex: "activePassiveTypeName",
      width: 150
    },
    {
      title: "修改人",
      dataIndex: "createdByName",
      ellipsis: true,
      width: 120
    },
    {
      title: "修改时间",
      dataIndex: "lastUpdatedTime",
      itemType: 'dateTime',
      width: 200
    }
  ],
  search: false,
  footer: false,
};

export default config;
